for (const e of document.querySelectorAll('.faq__element')) {
	e.addEventListener('click', function () {
		this.classList.toggle('faq__element--open');
	});
}
